module.exports = __webpack_public_path__ + "media/location/drone-40c242ce.png";